// extracted by mini-css-extract-plugin
export default {"MONTH":"y00EYi","month":"y00EYi","DAY":"l9403R","day":"l9403R","YEAR":"Zv8q2N","year":"Zv8q2N","fields":"NPI5hQ","mobile":"NQthpM"};